import { FastFieldProps } from "formik";
import React from "react";
import { trueOrUndef } from "../../utils/dom-attribute-helpers";
import Input from "../input/Input";
import {
  RelatedContentSelector,
  useRelatedContentContext
} from "./CustomMarkdownComponents";
import { FormFieldElement, FormFieldInputWrapper } from "./FormFieldElement";
import { FormFieldLabel } from "./FormFieldLabel";

type Props = { label: string; name: string } & React.ComponentPropsWithoutRef<
  typeof Input
> &
  FastFieldProps & { outerProps?: React.ComponentRef<typeof FormFieldElement> };
const TextField: React.FC<Props> = ({
  label,
  name,
  field,
  meta,
  outerProps,
  ...props
}) => {
  const showError = meta.touched && !!meta.error;
  const { isSelected, related } = useRelatedContentContext(
    name as RelatedContentSelector
  );

  return (
    <FormFieldElement data-related-selected={isSelected} {...outerProps}>
      <FormFieldLabel htmlFor={props.id}>{label}</FormFieldLabel>
      <FormFieldInputWrapper>
        <Input
          {...field}
          {...props}
          data-error={trueOrUndef(showError)}
          name={name}
          aria-invalid={trueOrUndef(showError)}
          aria-errormessage={showError ? meta.error : undefined}
        />
        {related}
      </FormFieldInputWrapper>
    </FormFieldElement>
  );
};

export default TextField;
